import React, { Component, } from 'react'

import '../styles.css';

class ClockJobTeamItem extends Component {
  constructor(props) {
    super(props);

    this.state={
      clockInfo: props.clockInfo
    }
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      clockInfo: nextProps.clockInfo
    })
  }

  renderShifts() {
    const shifts = [];

    shifts.push({
      key: 0,
      timeIn: this.state.clockInfo.timeIn,
      timeOut: this.state.clockInfo.timeOut
    });

    const allShifts = this.state.clockInfo.shifts;
    if (allShifts)
    for (const key in allShifts) {
      if (allShifts[key]._type === 'deleted') {
        continue;
      }

      shifts.push(allShifts[key]);
      shifts[shifts.length - 1].key = key;
    }

    shifts.sort((s1, s2) => {
      return s1.timeIn === s2.timeIn
        ? s1.timeOut > s2.timeOut
        : s1.timeIn > s2.timeIn;
    })

    return shifts.map(this.renderShift.bind(this));
  }

  renderShift(shift) {
    return (
      <div
        key={shift.key}
        style={{ marginTop: 4 }}>

        <span
          className="field-label">
          {
            (shift.timeIn ? shift.timeIn : '')
            + ' - ' +
            (shift.timeOut ? shift.timeOut : '')
          }
        </span>
      </div>
    );
  }

  render() {
    return (
      <div
        style={{ display: 'flex', flexDirection: 'column',
          marginLeft: 20, marginBottom: 10 }}>
        <span
          style={{ color: 'rgba(0,0,0,0.8)', fontSize: 14 }}>
          {this.props.name}
        </span>

        { this.renderShifts() }
      </div>
    );
  }
}

export default ClockJobTeamItem;



// WEBPACK FOOTER //
// ./src/schedule/common/modules/clockJob/ClockJobTeamItem.js